import React, { useRef } from 'react';
import ExpandingTagItem from './expanding-tag';
import { useDrag, useDrop } from 'react-dnd';
import { TYPES } from '../../constants/constants';
import PropTypes from 'prop-types';

export default function DraggableExpandingTagItem(props) {
  const { data, moveItem, dragStop } = props;
  const ref = useRef(null);

  const [, connectDropTarget] = useDrop({
    accept: TYPES.DRAGGABLETAG,
    hover: (item, monitor) => {
      if (!ref.current) {
        return
      }

      const dragIndex = item.number;
      const hoverIndex = data.number;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect()

      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

      // Determine mouse position
      const clientOffset = monitor.getClientOffset()

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }

      // Time to actually perform the action
      moveItem(dragIndex, hoverIndex)
    }
  });

  const [{ isDragging }, connectDragSource] = useDrag({
    type: TYPES.DRAGGABLETAG,
    item: () => ({ number: data.number, id: data._id.$oid }),
    end: () => dragStop(),
    isDragging: monitor => data._id.$oid === monitor.getItem().id,
    collect: monitor => ({ isDragging: monitor.isDragging() })
  });

  connectDragSource(connectDropTarget(ref));

  const css = {opacity : isDragging ? 0.2 : 1}

  return (
    <div ref={ref} style={css}><ExpandingTagItem {...props} /></div>
  );
}

DraggableExpandingTagItem.propTypes = {
  moveItem: PropTypes.func.isRequired,
  dragStop: PropTypes.func.isRequired,
  data: PropTypes.shape({
    sort: PropTypes.number,
    _id: PropTypes.object.isRequired
  })
}
